export default "__VITE_ASSET__CtZg_KFO__"